import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import BankTwoToneSvg from "@ant-design/icons-svg/es/asn/BankTwoTone";
import AntdIcon from "../components/AntdIcon";
var BankTwoTone = function BankTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: BankTwoToneSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  BankTwoTone.displayName = 'BankTwoTone';
}
export default /*#__PURE__*/React.forwardRef(BankTwoTone);